import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

import { useAppDispatch } from "../../../redux/useAppDispatch";
import UploadButton from "../../Template/Buttons/UploadButton/UploadButton";
import Search from "antd/es/input/Search";
import { fetchInprogressAudios, resetInProgressTable, searchInProgressAudios, stopInProgressAutoRefresh, updateInProgressRequestBody } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { fetchArchivedAudios, resetArchivedTable, searchArchivedAudios, stopArchivedAutoRefresh, updateArchivedRequestBody } from "../../../redux/JobModule/ArchivedPage/ArchivedAction";
import { clearFilter, getPicklist, resetFilter, setSearchKeyword, updateFilterValues } from "../../../redux/Transcribe/TranscribeAction";
import { fetchNewCompletedAudios, searchNewCompletedAudios, resetNewCompletedTable, updateNewCompletedRequestBody, stopNewCompletedAutoRefresh } from "../../../redux/JobModule/CompletedPage/NewCompletedAction";
import { useNavigate } from "react-router";
import { set } from "lodash";

interface Props {
  tab: string;
}

function FilterComponent(props: Props) {
  const searchKeyword = useSelector((state: RootState) => state.TranscribeState.searchKeyword);
  const [searchValue, setSearchValue] = useState(searchKeyword);
  const completedRequestBody = useSelector((state: RootState) => state.NewCompletedAudiosState.currentRequestBody);
  const inprogressRequestBody = useSelector((state: RootState) => state.InProgressAudiosState.currentRequestBody);
  const archivedRequestBody = useSelector((state: RootState) => state.ArchivedAudiosState.currentRequestBody);
  const pickListValue = useSelector((state: RootState) => state.TranscribeState.pickList);
  const pickListLoading = useSelector((state: RootState) => state.TranscribeState.pickListLoading);
  const filterValues = useSelector((state: RootState) => state.TranscribeState.filterValues);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const getSearchAndResetFunctions = () => {
    if (props.tab === "completed") {
      return {
        fetchAudio: fetchNewCompletedAudios,
        searchAudio: searchNewCompletedAudios,
        resetTable: resetNewCompletedTable,
        updateRequestBody: updateNewCompletedRequestBody,
        requestBody: completedRequestBody,
        stopAutoRefresh: stopNewCompletedAutoRefresh,
      };
    } else if (props.tab === "inprogress") {
      return {
        fetchAudio: fetchInprogressAudios,
        searchAudio: searchInProgressAudios,
        resetTable: resetInProgressTable,
        updateRequestBody: updateInProgressRequestBody,
        requestBody: inprogressRequestBody,
        stopAutoRefresh: stopInProgressAutoRefresh,
      };
    } else {
      return {
        fetchAudio: fetchArchivedAudios,
        searchAudio: searchArchivedAudios,
        resetTable: resetArchivedTable,
        updateRequestBody: updateArchivedRequestBody,
        requestBody: archivedRequestBody,
        stopAutoRefresh: stopArchivedAutoRefresh,
      };
    }
  };

  const { fetchAudio, resetTable, updateRequestBody, requestBody } = getSearchAndResetFunctions();
  const onSearchAudios = (value: string) => {
    dispatch(setSearchKeyword(value));
    dispatch(fetchAudio({}));
  };
  const filterTable = (type: string, value: any) => {
    if (type === "tenant") {
      const newRequestBody = {
        ...requestBody,
        TenantId: value,
      };
      dispatch(updateRequestBody(newRequestBody));
      dispatch(updateFilterValues({ ...filterValues, TenantId: value }));
      dispatch(fetchAudio({}));
    } else if (type === "pack") {
      const newRequestBody = {
        ...requestBody,
        PackPriorityId: value,
      };
      dispatch(updateRequestBody(newRequestBody));
      dispatch(updateFilterValues({ ...filterValues, PackPriorityId: value }));
      dispatch(fetchAudio({}));
    } else if (type === "type") {
      dispatch(resetTable());
      const newRequestBody = {
        ...requestBody,
        TranscriptionTypeId: value,
      };
      dispatch(updateRequestBody(newRequestBody));
      dispatch(updateFilterValues({ ...filterValues, TranscriptionTypeId: value }));
      dispatch(fetchAudio({}));
    } else {
      const newRequestBody = {
        ...requestBody,
        StatusId: value,
      };
      dispatch(updateRequestBody(newRequestBody));
      dispatch(updateFilterValues({ ...filterValues, StatusId: value }));
      dispatch(fetchAudio({}));
    }
  };

  useEffect(() => {
    if (props.tab === "inprogress") {
      // dispatch(stopInProgressAutoRefresh());
      dispatch(updateFilterValues({ ...filterValues, StatusId: 0 }));
    } else if (props.tab === "completed") {
      // dispatch(stopNewCompletedAutoRefresh());
      dispatch(updateFilterValues({ ...filterValues, StatusId: 3 }));
    } else if (props.tab === "archived") {
      // dispatch(stopArchivedAutoRefresh());
      dispatch(updateFilterValues({ ...filterValues, StatusId: 5 }));
    }
    dispatch(getPicklist({}));
    // return () => {
    //   dispatch(resetFilter());
    // };
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between gap-3">
        <div className="d-flex justify-content-between">
          <button
            onClick={() => {
              dispatch(clearFilter());
              // dispatch(fetchAudio({}));
              dispatch(resetInProgressTable());
              dispatch(fetchInprogressAudios({}));
              navigate("/auth/inprogress");
            }}
            style={{
              background: "none",
              border: "none",
              color: "black",
              cursor: "pointer",
              textDecoration: "underline",
            }}>
            Clear filters
          </button>
        </div>

        {/* TENANT FILTER */}
        <div className="d-flex justify-content-between">
          <Select
            style={{ width: 150, marginTop: "5px" }}
            loading={pickListLoading}
            value={pickListValue.tenantPicklist.find((item) => item.value === filterValues.TenantId)?.value}
            defaultValue={"Organization"} // Set default value here
            onSelect={(value) => {
              filterTable("tenant", value);
            }}
            showSearch
            options={pickListValue.tenantPicklist}
          />
        </div>

        {/* PACK PRIORITY */}

        <div className="d-flex justify-content-between">
          <Select
            style={{ width: 150, marginTop: "5px" }}
            loading={pickListLoading}
            value={pickListValue.priorityPicklist.find((item) => item.value === filterValues.PackPriorityId)?.value}
            defaultValue="Priority" // Set default value here
            onSelect={(value) => {
              filterTable("pack", value);
              //  dispatch(filterNewCompletedAudiosPack({ Pack: value }));
            }}
            showSearch
            options={pickListValue.priorityPicklist}
          />
        </div>

        {/* TYPE */}

        <div className="d-flex justify-content-between">
          <Select
            style={{ width: 150, marginTop: "5px" }}
            loading={pickListLoading}
            value={pickListValue.transcriptionPicklist.find((item) => item.value === filterValues.TranscriptionTypeId)?.value}
            defaultValue="Type" // Set default value here
            onSelect={(value) => {
              filterTable("type", value);
            }}
            showSearch
            options={pickListValue.transcriptionPicklist}
          />
        </div>

        {/*  STATUS */}
        <div className="d-flex justify-content-between">
          <Select
            style={{ width: 150, marginTop: "5px" }}
            loading={pickListLoading}
            value={pickListValue.statusPicklist.find((item) => item.value === filterValues.StatusId)?.value}
            defaultValue="Status" // Set default value here
            onSelect={(value) => {
              dispatch(updateFilterValues({ ...filterValues, StatusId: value }));
              if (value === 3) {
                navigate("/auth/completed");
              } else if (value === 5) {
                navigate("/auth/archived");
              } else {
                filterTable("status", value);
                // dispatch(filterNewCompletedAudiosPack({ Pack: value }));
                navigate("/auth/inprogress");
              }
            }}
            showSearch
            options={pickListValue.statusPicklist}
          />
        </div>

        <div className="d-flex justify-content-between ">
          <Search
            className="bold-placeholder"
            type="text"
            size="large"
            value={searchValue}
            onSearch={(value) => onSearchAudios(value)}
            allowClear
            placeholder="Search Packs"
            onChange={(e) => setSearchValue(e.target.value)}
            style={{ width: 300 }}
          />
        </div>
        <div className="d-flex justify-content-between">
          <UploadButton />
        </div>

        {/* <div
          className="d-flex justify-content-between h-100 "
          style={{ display: "none" }}>
          <AutoRefreshNewCompletedCheckbox />
        </div> */}
      </div>
    </>
  );
}

export default FilterComponent;
